import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { QrCode, ArrowLeft } from "lucide-react";
import { Brand } from "@/components/brand";
import { useSeo } from "@/lib/seo";

export const NotFound = () => {
  useSeo({ title: "Sayfa bulunamadı · RateGuard", noindex: true });
  return (
  <div className="scene flex flex-col" style={{ minHeight: "100dvh" }}>
    <div className="floor" />
    <header className="wrap pt-6">
      <Brand />
    </header>
    <main className="wrap flex-1 grid place-items-center py-16">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="panel panel-rim text-center"
        style={{ maxWidth: 440, padding: "2.4rem 2rem" }}
      >
        <div className="step-token mx-auto mb-6" style={{ width: 64, height: 64 }}>
          <QrCode size={28} />
        </div>
        <h1 className="display" style={{ fontSize: "2.2rem" }} data-testid="not-found-title">
          Bu bağlantı bulunamadı
        </h1>
        <p className="muted mt-3">
          Otelinizin QR kodunu tekrar okutmayı deneyin ya da resepsiyondan doğru bağlantıyı isteyin.
        </p>
        <p className="faint text-sm mt-2">This link doesn't match any hotel. Please rescan the QR code in your room.</p>
        <Link to="/" className="btn btn-secondary btn-sm mt-7">
          <ArrowLeft size={16} /> RateGuard
        </Link>
      </motion.div>
    </main>
  </div>
  );
};

export default NotFound;
